import { useEffect, useMemo, useRef, useState } from "react";
import Table from "../../components/GTable/Table";
import { GetUsersData, GetUsersExportData } from "../../lib/data";
import Button from "../../components/GButton/Button";
import { stateOfusers, statusOfCategories, usersColumns } from "../../lib/definitions";
import { deleteUsersForm } from "../../lib/actions";
import DeleteRecord from "../../ui/Models/deleteRecord";
import Pagination from "../../ui/paginations/Paginations";
import TableSkeleton from "../../ui/sharedUi/tableSkeleton";
import { useSearchParams } from "react-router-dom";
import { MdOutlineFileUpload } from "react-icons/md";
import UsersFilter from "../../ui/searchFilter/usersFilter";
import { useLocation } from "react-router-dom";
import i18n from "../../lib/i18n";

export default function Users() {

    const [searchParams] = useSearchParams();
    const deleteRef = useRef(null);
    const [usersData, setUsersData] = useState([]);
    const [currentPage, setcurrentPage] = useState(1);
    const [last_page, setlast_page] = useState(1);
    const [deleteConfirmation, setDeleteConfirmation] = useState({ isOpen: false, idToDelete: null });
    const [isLoading, setIsLoading] = useState(true);  
    const [loadingDelete, setLoadingDelete] = useState(false); 
    const location = useLocation(); 
    const [showExportDialog, setShowExportDialog] = useState(false);
    const [exportData, setExportData] = useState([]);
    const t = i18n.t.bind(i18n); 

    // const user = JSON.parse(localStorage.getItem("userData"));
    // const userType = user.type;
    const created_at = searchParams.get('created_at');
    const name = searchParams.get('name');
    const status = searchParams.get('status');
    const email = searchParams.get('email');
    const phone = searchParams.get('phone');

    const params = useMemo(() => {
        const tempParams = [];
        if (created_at) tempParams.push({ created_at });
        if (name) tempParams.push({ name });
        if (status) tempParams.push({ status });
        if (email) tempParams.push({ email });
        if (phone) tempParams.push({ phone });

        return tempParams;
    }, [ status, created_at, name, email, phone]);

    useEffect(() => {
        handleApi();
    }, [currentPage, params])

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
            deleteRef.current && 
            !deleteRef.current.contains(event.target)
            ) {
            closeDeleteConfirmation();
            }
        };

        if (deleteConfirmation.isOpen) {
            document.addEventListener("mousedown", handleClickOutside);
        }
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [deleteConfirmation.isOpen]);


    const handleApi = async () => {
        setIsLoading(true); 
        const usersData = await GetUsersData(currentPage, params);
        setUsersData([]);
        setcurrentPage(usersData.pagination.current_page);
        setlast_page(usersData.pagination.last_page);
        usersData.data.map((e) => setUsersData((prev) => [...prev, e]));
        setIsLoading(false);  
    };

    const handlePageChange = (page) => {
        setcurrentPage(page);
    };

    const openDeleteConfirmation = (id) => {
        setDeleteConfirmation({ isOpen: true, idToDelete: id });
    };

    const closeDeleteConfirmation = () => {
        setDeleteConfirmation({ isOpen: false, idToDelete: null });
    };

    const handelDelete = async () => {
        if (deleteConfirmation.idToDelete) {
            setLoadingDelete(true);
            const result = await deleteUsersForm(deleteConfirmation.idToDelete);
            if (result) {
                setLoadingDelete(false);
                handleApi();
            }
            closeDeleteConfirmation();
        }
    };

    const openCloseExportDialog = (e) => {
        setShowExportDialog(e);
    };

    const ExportTableWithPaginiation = async (e) => {
        const exportData = await GetUsersExportData(e, params);
        setExportData([]);
        exportData.data.map((e) => setExportData((prev) => [...prev, e]));
    };

    return (
        <div className="p-8 sm:p-6 md:p-8">
            {/* {userType == "employee" && ( */}
            {location.pathname === "/users" &&
                <div className="">
                    <UsersFilter stateOfusers={stateOfusers} values={params} />
                </div>
            }
            <div className="flex flex-col sm:flex-row sm:items-baseline border-t border-gray-500/100 bg-thirdly  justify-between px-5 py-5  gap-4">
                <div></div>
                <div onClick={()=>openCloseExportDialog(true)}>
                    <Button background="#232424" borderRadius="8px" border="border border-gray-500/80" color="white" padding="8px 24px" text={t("button.export")} icon={<MdOutlineFileUpload />} />
                </div>
            </div>
            <div>
                {isLoading ? <TableSkeleton cols={usersColumns}/> : (  
                    <Table name={"Users"} showExportDialog={showExportDialog} openCloseExportDialog={openCloseExportDialog} ExportTableWithPaginiation={ExportTableWithPaginiation} rowsExportPaginiation={exportData} columns={usersColumns} rows={usersData} openDeleteConfirmation={openDeleteConfirmation} edit="/users/details" />
                )}
            </div>
            <div className="flex justify-center items-center py-5">
                <Pagination currentPage={currentPage} totalPages={last_page} handleChangePage={handlePageChange} />
            </div>
            {deleteConfirmation.isOpen && <DeleteRecord ref={deleteRef} loadingDelete={loadingDelete} handelDelete={handelDelete} closeDeleteConfirmation={closeDeleteConfirmation} />}
        </div>
    );
};